import "../spinner.scss";

export const Loader = () => {
    return(
        <div>
            <div className="loadingio-spinner-rolling-b5r1h5c8y1e">
                <div className="ldio-bwr06vgawvp">
                    <div></div>
                </div>
            </div>
        </div>
    )
}